export const encodeQueryParams = (params) => {
  return Object.keys(params)
    .map(key => [key, params[key]].map(encodeURIComponent).join('='))
    .join('&')
}

export const URL_PARAM_FILTERS = {
  'like': 'like.',
  'ilike': 'ilike.',
  'equals': 'eq.',
  'notequals': 'not.eq.',
  'isnot': 'not.is.',
  'is': 'is.',
  'none': ''
}

/**
 * taktes the column name and filterName to match up
 * the correct filter keywords.
 * @param  {string} name column to filter on
 * @param  {string} filterName the filter mode, equals, like etc
 * @param  {string} value the value we are filtering
 */
export const valueToUrlFilter = (name, filterName, value) => {
  return `${name}=${URL_PARAM_FILTERS[filterName]}${value}`
}

/**
 * takes in params, key'd by column name we are filtering on
 * and takes the filter mode and value keys and constructs
 * url query params
 * @param  {object} params={}
 */
export const buildUrlFilterParams = (params = {}) => {
  const out = []
  Object.keys(params).forEach((key) => {
    let {value, filter} = params[key]
    value = value ? String(value).trim() : undefined
    if ((value && filter) && value !== '') {
      out.push(valueToUrlFilter(key, filter, value))
    }
  })
  return out.join('&')
}
